import { ChangeDetectionStrategy, Component } from '@angular/core';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { isFalsy } from '@sama/js-core';
import { map } from 'rxjs/operators';
import { PointCloudStore } from '../../../../../outputs/annotation/point-cloud/state/point-cloud-store';
import { EventTrackingService } from '../../../../../shared/event-tracking/event-tracking.service';

@Component({
  selector: 'h3-side-view-toggle-button',
  templateUrl: './side-view-toggle-button.component.html',
  styleUrls: ['./side-view-toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SideViewToggleButtonComponent {
  faAngleDoubleRight = faAngleDoubleRight;
  disabled$ = this.store('sideViewsIsAllowed').$.pipe(map(isFalsy));
  flip$ = this.store
    .getTransientFromActiveMeshLayer$('sideViewsExpanded')
    .pipe(map((expanded) => (expanded ? 'horizontal' : undefined)));

  constructor(
    public store: PointCloudStore,
    private eventTrackingService: EventTrackingService,
  ) {}

  toggleExpanded() {
    const sideViewsExpanded = !this.store.getActiveLayerStore().state()
      .transient.sideViewsExpanded;
    this.store
      .getActiveLayerStore()('transient')('sideViewsExpanded')
      .set(sideViewsExpanded);
    this.eventTrackingService.track({
      id: 'toggle_3d_side_panels',
      bucket: 'navigation',
      sub_bucket: 'frame',
      expanded: sideViewsExpanded,
    });
  }
}
